import axios from 'axios';
import { combineReducers } from 'redux';
import { startSubmit, stopSubmit } from 'redux-form';

import * as Urls from 'src/constants/EndpointUrls';
import { concatParamsToUrl, redirectTo } from 'src/utils/Http';
import { setGlobalErrors, setGlobalSuccesses } from 'src/reducers/global';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import {
  newItemFailure,
  editItem,
  editItemFailure,
  deleteItem,
  deleteItemFailure,
  getItemErrors,
  mergeItemFields
} from 'src/reducers/common/itemReducer';
import { setList } from 'src/reducers/common/listReducer';
import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';
import { sortingFormDate } from 'src/features/PayrollRulesGroups/utils';
import { getTutorialStep2, setTutorialStep2 } from '../../utils/Tutorial';

export const REDUCER_NAME = 'payrollRulesGroups';
export const getPayrollRulesGroupsList = state => state[REDUCER_NAME].list.data;
export const setPayrollRulesGroupsList = data => setList(REDUCER_NAME, { data });

export const getDeletePayrollRulesGroupError = state => getItemErrors(REDUCER_NAME, state);
export const clearErrors = () => dispatch => dispatch(deleteItem(REDUCER_NAME, []));

// Async Action Creators
export const newPayrollRulesGroup = data => async dispatch => {
  try {
    const sortedData = data.paymentCount === 'twice' ? sortingFormDate(data) : data;
    dispatch(startSubmit(PAYROLL_RULES_GROUP_FORM));
    await axios.post(Urls.CREATE_CLIENT_PAYROLL_RULES_GROUP_URL, sortedData);
    const tutorialStep2 = getTutorialStep2();
    if (tutorialStep2) {
      const { run, tourCompleted, params } = tutorialStep2;
      if (run) {
        setTutorialStep2({ run, stepIndex: 0, tourCompleted, type: 'check', params });
      }
    }
    redirectTo(Urls.CLIENT_PAYROLL_RULES_GROUP_LIST);
  } catch (exception) {
    dispatch(stopSubmit(PAYROLL_RULES_GROUP_FORM));
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const checkDataPayrollRulesGroup = () => async dispatch => {
  try {
    dispatch(startSubmit(PAYROLL_RULES_GROUP_FORM));
  } catch (exception) {
    dispatch(stopSubmit(PAYROLL_RULES_GROUP_FORM));
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const delPayrollRulesGroup = payrollRulesGroupId => async dispatch => {
  try {
    dispatch(deleteItem(REDUCER_NAME));
    await axios.delete(concatParamsToUrl(Urls.UPDATE_CLIENT_PAYROLL_RULES_GROUP_URL, { id: payrollRulesGroupId }));
    redirectTo(Urls.CLIENT_PAYROLL_RULES_GROUP_LIST);
  } catch (exception) {
    dispatch(deleteItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const editPayrollRulesGroup = data => async dispatch => {
  try {
    dispatch(editItem(REDUCER_NAME));
    const sortedData = data.paymentCount === 'twice' ? sortingFormDate(data) : data;
    await axios.put(concatParamsToUrl(Urls.UPDATE_CLIENT_PAYROLL_RULES_GROUP_URL, { id: data.id }), sortedData);
    redirectTo(Urls.CLIENT_PAYROLL_RULES_GROUP_LIST);
  } catch (exception) {
    dispatch(editItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const settingPaymentDate = (data, callback) => async dispatch => {
  try {
    const resp = await axios.put(Urls.SETTING_PAYMENT_DATES_CLIENT_PAYROLL_RULES_GROUPS, data);
    dispatch(setGlobalSuccesses(resp.data.payload.message));
    if (typeof callback === 'function') {
      callback();
    }
    dispatch(setPayrollRulesGroupsList(resp.data.payload.payrollRulesGroups));
    dispatch(mergeItemFields(REDUCER_NAME, { warningMessages: resp.data.payload.alertMessages }));
  } catch (e) {
    dispatch(setGlobalErrors(e.message));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
